import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import React from 'react';


import Navbar from './Components/Navbar'
import Footer from './Components/Footer';
import MainPage from './Components/MainPage/MainPage';
import SurveyStudio from './Components/SurveyStudio/SurveyPage';
import DialerExpress from './Components/DialerExpress/DialerPage';
import Error404 from './Components/404';
import News from "./Components/News/NewsPage";


class App extends React.Component {

    render() {
        return (
            <Router>
                <div className={'wrapper'}>
                    <Navbar/>
                    <Switch>
                        <Route exact path='/' component={MainPage}  />
                        <Route path='/surveystudio' component={SurveyStudio} />
                        <Route path='/dex' component={DialerExpress} />
                        <Route path='/news' component={News}/>
                        <Route component={Error404}/>
                    </Switch>
                    <Footer/>
                </div>
            </Router>
        )
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js